import React from 'react';
import { Link, browserHistory } from 'react-router';
import cookie from 'react-cookie';
import { connect } from 'react-redux';
import { ShowIf } from 'components/utils';
import { API_URL, API_SSO_URL, checkServerLive } from 'constants/config';
// import {checkThamSo} from "constants/checkThamSo";
import { User } from 'api';
import { get } from 'lodash';

let userIcon = require('assets/images/user.png');

class Profile extends React.Component {

  // checkVaiTro() {
  //   let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
  //   let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

  //   if (ThamSo.length > 0 && userInfo != {}) {
  //     if (checkThamSo() != null) {
  //       return false
  //     } else {
  //       return true
  //     }
  //   } else {
  //     return true
  //   }
  // }

  clearAllCookie() {
    document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
  }

  handleLogOut() {
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    User.actions.logout.request().then(res => {
      if (get(userInfo, 'sso')) {
        cookie.remove('accessToken', { path: '/' })
        this.props.dispatch({
          type: 'RESET_DLHT'
        });
        this.clearAllCookie();
        localStorage.removeItem('userInfo');
        localStorage.removeItem('thamSo');
        window.location.href = `https://login.quangngai.gov.vn/oidc/logout?post_logout_redirect_uri=https://quanlythanhtra.quangngai.gov.vn/api/sso/logout&id_token_hint=${get(userInfo, 'ssoIdToken')}`;
      } else {
        cookie.remove('accessToken', { path: '/' })
        this.props.dispatch({
          type: 'RESET_DLHT'
        });
        this.clearAllCookie();
        localStorage.removeItem('userInfo');
        localStorage.removeItem('thamSo');
        browserHistory.push('/dang-nhap');
      }
    });
  }

  handleSwitchRole(item) {

  }

  render() {
    return (
      <div className="profile-wrap">
        <div className="profile-list">
          <div className="profile-item item-has-children" style={{ zIndex: 3 }}>
            <Link className='wrap-name'>
              <img src={userIcon} className="user-ico" alt="user-icon" />
              <span className="user-name">{this.props.userInfo.name}
                <ShowIf condition={this.props.userInfo.chucVu != '' && this.props.userInfo.chucVu != null}>
                  <span>
                    <span className='hide-small'> - </span><br />{this.props.userInfo.chucVu}
                  </span>
                </ShowIf>
              </span>
            </Link>
            <div className="sub-profile">
              <div className="item"><Link to="/thay-doi-mat-khau">Đổi mật khẩu</Link></div>
              <div className="item" onClick={this.handleLogOut.bind(this)}><Link>Đăng xuất</Link></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

let mapStateToProps = state => {
  return {
    isLogin: typeof cookie.load('accessToken') != 'undefined' ? true : false,
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  }
}

export default connect(mapStateToProps)(Profile);



// WEBPACK FOOTER //
// ./src/components/layout/partials/Profile.jsx